import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "pr-4"
};
import { app } from "@/di";
import { Region } from "@/modules/base/entity";
import { Team } from "@/modules/team/entity";
import RegionComponent from "@/modules/youth/components/scouting/Region.vue";
import YouthPlayerSlim from "@/modules/youth/components/scouting/YouthPlayerSlim.vue";
import { Recruiter } from "@/modules/youth/services/Recruiter";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const regions = ref();
    const team = ref();
    const recruitedSlots = ref({
      recruited: 0,
      total: 0
    });
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      regions.value = await Region.createQueryBuilder('region').getMany();
      team.value = await Team.createQueryBuilder('team').leftJoinAndSelect('team.youthPlayers', 'youthPlayer').leftJoinAndSelect('youthPlayer.recruitedBy', 'recruitedBy').innerJoinAndSelect('youthPlayer.country', 'country').where('team.user = true').getOneOrFail();
      const recruiter = app.get(Recruiter);
      recruitedSlots.value = {
        recruited: await recruiter.getUsedSlots(team.value),
        total: await recruiter.getSlots(team.value)
      };
    })), __temp = await __temp, __restore(), __temp);
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('scouting')), 1)]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('youth_players_recruited', recruitedSlots.value)), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regions.value, region => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: region.id
          }, [_createVNode(RegionComponent, {
            region: region,
            class: "py-2 border-y first:border-t-0",
            onUpdated: _unref(refresh)
          }, null, 8, ["region", "onUpdated"]), !team.value.youthPlayers.find(p => p.country.regionId === region.id) ? (_openBlock(), _createBlock(_component_NEmpty, {
            key: 0,
            description: _ctx.$t('no_youth_players_scouted_yet')
          }, null, 8, ["description"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.value.youthPlayers.filter(p => p.country.regionId === region.id), player => {
            return _openBlock(), _createBlock(YouthPlayerSlim, {
              key: player.id,
              player: player,
              class: "py-2",
              onUpdated: _unref(refresh)
            }, null, 8, ["player", "onUpdated"]);
          }), 128))]))], 64);
        }), 128))]),
        _: 1
      });
    };
  }
});